import React from 'react';
import Image from '@ecs/tng-common/components/image/Image';
import Modal from 'react-bootstrap/Modal';
import { formCTAurl, SigninRefPath } from '@ecs/tng-common/scripts/registration';
import { sharedIconsPath } from '@ecs/tng-common/scripts/data';
import DisclosureWithSymbol from '@ecs/tng-common/components/disclosure-with-symbol/DisclosureWithSymbol';
import { scoreBoostResults } from '@ecs/tng-common/documents/disclosures/regulatory';

export type BoostCtaModalProps = {
  show: boolean;
  onHide?: () => void;
  className?: string;
};
class BoostCtaModal extends React.Component<BoostCtaModalProps> {
  componentDidUpdate(prevProps: BoostCtaModalProps) {
    if (
      prevProps.show !== this.props.show &&
      typeof window !== 'undefined' &&
      window.opAppend &&
      this.props.show
    ) {
      window.opAppend();
    }
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        fullscreen="sm-down"
        className={`${this.props.className || ''}`}>
        <Modal.Header closeButton />

        <Modal.Body>
          <div className="d-flex">
            <div>
              <h3>Instantly raise your credit scores for free</h3>
              <p className="text-gray">
                Get credit for bills like your cell phone, utilities, rent and insurance with
                Experian Boost<sup>®</sup>.<sup>ø</sup>
              </p>
              <p className="h7 mb-5">No credit card required</p>
            </div>
            <Image
              className="ms-4 d-block mx-auto"
              alt="Experian boost icon."
              src={`${sharedIconsPath}/icon-boost-rocket.svg`}
              width="190"
              height="118"
              lazyLoading
            />
          </div>
          <div className="bg-coconut p-3 rounded disclosures">
            <DisclosureWithSymbol disclosure={scoreBoostResults} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <a
            onClick={() => (this.props.onHide ? this.props.onHide() : null)}
            className="btn btn-primary"
            href={formCTAurl({
              offer: 'at_frsas119',
              authType: '102',
              refUrl: SigninRefPath.boostOnboarding
            })}
            data-op="MOD">
            Start your boost
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default BoostCtaModal;
